/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */


import React from 'react';

const buttonPayStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
  backgroundColor: 'orange',
  color: 'white',
};

class EmptyFileDownloader extends React.Component {

  render() {
    let className = 'btn btn-warning pull';
    if (this.props.className) {
      className = this.props.className;
    }
    return (
      <a
        className={`${className}-${this.props.position}`}
        target="_blank"
        href={`${process.env.API_URL}/eservices/${this.props.prefix}/${this.props.serviceType}/getEmptyDoc`}
        style={buttonPayStyle}
      >
        Pobierz formularz
      </a>
    );
  }

}

export default EmptyFileDownloader;



// WEBPACK FOOTER //
// src/components/EmptyFileDownloader/EmptyFileDownloader.js